<template>
    <div>
        <Header :sel='4' @changePhone="changePhone" />
        <div :class="['cd-main-content', showPhone ? 'nav-is-visible' : '']">
            <!-- your content here -->
            <!--banner-->
            <div class="banner"> </div>
            <!--banner-->

            <!--neirong-->
            <div class="bread_bg">
                <div class="bread"> <a href="/">首页</a> - <a href="javascript:void(0)">荣誉资质</a></div>
            </div>
            <div class="neirong">


                <ul class="rongyu_list">
                    <li v-for="item in list2"><el-image :src="item.image"
									:preview-src-list="[item.image]">
                        </el-image></li>

                </ul>
                <!--上面调用横着的，下面调用竖着的-->
                <ul class="rongyu_list">
                    <li v-for="item in list"><el-image :src="item.image"
									:preview-src-list="[item.image]">
                        </el-image></li>

                </ul>
            </div>
        </div>
        <Footer></Footer>

    </div>


</template>

<script>
import Header from '@/components/header.vue'
import Footer from '@/components/footer.vue'
import { getHonorList } from '@/api/reqFetch.js'
export default {
    name: '',
    layout: '',
    components: {
        Footer,
        Header
    },
    data() {
        return {
            list: [],
            pageNum: 1,
            list2: [],
            indexs: [],
            totalPage: 0,
            showPhone: false,
            list2: []
        }
    },

    mounted() {
        this.getData()
    },


    methods: {
        changePhone(val) {
            this.showPhone = val
        },
        goNext(url) {
            this.$router.push({
                path: url,
            })
        },
        selData(id, name) {
            this.selName = name
            this.type = id;
            this.getData()
        },
        getData() {
            let par = {
                pageNumber: 1,
                pageSize: 999,

            }
            getHonorList(par).then(res => {
                const tempList = [];
                const tempList2 = [];
                // 遍历原始数据
                res.data.list.forEach(item => {
                    // 根据direction分组
                    if (item.direction == 1) {
                        tempList.push(item);
                    } else if (item.direction == 2) {
                        tempList2.push(item);
                    }
                });
                // 赋值到组件数据
                this.list = tempList;
                this.list2 = tempList2;

            });
        },
        goDetail(id) {
            this.$router.push({
                path: '/context',
                query: { id: id }
            })
        }

    }
}
</script>

<style scoped>
.banner {
    background-image: url('../../assets/images/banner_06.png');
}
</style>
